import { useEffect, useState } from "react"
import { getRejectReasonsRequest } from "../../services/wisdomServices/requestService"
import { Dialog } from "primereact/dialog"
import { Dropdown } from "primereact/dropdown"
import { Button } from "primereact/button"

export function RejectReasonDialog({type, onClose, open, onReject}){
    const [reasons, setReasons] = useState([])
    const [selectedReason, setSelectedReason] = useState(null) 

    const hideDialog = () => {
        setSelectedReason(null);
        onClose();
    }
    
    const selectRejectReason = async() => {
        onReject(selectedReason)
        setSelectedReason(null)
        onClose();
    }

    const rejectReasonFooterDialog = (
        <div>
            <Button label="Cancel" icon="pi pi-times" outlined onClick={hideDialog}/>
            <Button label="Save" icon="pi pi-check" outlined onClick={selectRejectReason} disabled={!selectedReason}/>
        </div>
    )

    const rejectReasonHeaderDialog = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="font-bold white-space-nowrap">Reject Request</span>
        </div>
    )

    const loadReasons = async() => {
        const reasonsList = await getRejectReasonsRequest(type)
        setReasons(reasonsList.data)
    }

    useEffect(() => {
        loadReasons()
    }, [type])

    return(
        <div>
            <Dialog
                dismissableMask
                visible={open}
                onHide={hideDialog}
                header={rejectReasonHeaderDialog}
                footer={rejectReasonFooterDialog}
                modal
                style={{ width: '25rem' }}
            > 
                <Dropdown 
                    tooltip="Select the reject reason"
                    value={selectedReason}
                    options={reasons}
                    optionLabel="description"
                    optionValue="id"
                    onChange={(e) => setSelectedReason(e.value)}
                    placeholder="Select a reason"
                />
            </Dialog>

        </div>
    )
}